<script setup lang="ts">
  import { HLCard } from '@platform-ui/highrise'

  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
  })

  defineOptions({ inheritAttrs: false, name: 'CPCard' })
</script>

<template>
  <HLCard :id="props.id" v-bind="$attrs">
    <slot />
  </HLCard>
</template>
